import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Misuratorifiscali_table_interface } from '@bludata/common-interfaces';
import { ParametriCassa_interface } from '../../configurazione/ecr/interface/ParametriCassa_interface';
import { ConfigurazioneWeb_interface } from '../../configurazione/impostazioniFWeb/interfaces/configurazioneWeb_interface';

export interface ConfigurazioneSliceState {
  configurazioneEcrEdit: Misuratorifiscali_table_interface | null;
  configurazioneEcrParametriCassaEdit: ParametriCassa_interface | null;
  configurazioneEcrCassaSel: string;
  ricercaConfigurazione: string;
  configurazioneWeb: ConfigurazioneWeb_interface;
  openConfigurazioneSTS: boolean;
  menuConfigOpened: boolean;
}

const initialState: ConfigurazioneSliceState = {
  configurazioneEcrEdit: null,
  configurazioneEcrParametriCassaEdit: null,
  configurazioneEcrCassaSel: '',
  ricercaConfigurazione: '',
  configurazioneWeb: null,
  openConfigurazioneSTS: false,
  menuConfigOpened: true,
};

export const ConfigurazioneSlice = createSlice({
  name: 'configurazione',
  initialState,
  reducers: {
    setConfigurazioneEcrEdit(
      state: ConfigurazioneSliceState,
      action: PayloadAction<Misuratorifiscali_table_interface>
    ) {
      state.configurazioneEcrEdit = action.payload;
    },
    setConfigurazioneEcrParametriCassaEdit(
      state: ConfigurazioneSliceState,
      action: PayloadAction<ParametriCassa_interface>
    ) {
      state.configurazioneEcrParametriCassaEdit = action.payload;
    },
    setConfigurazioneEcrCassaSel(
      state: ConfigurazioneSliceState,
      action: PayloadAction<string>
    ) {
      state.configurazioneEcrCassaSel = action.payload;
    },
    resetConfigurazioneEcrEdit(state: ConfigurazioneSliceState) {
      state.configurazioneEcrEdit = initialState.configurazioneEcrEdit;
      state.configurazioneEcrParametriCassaEdit =
        initialState.configurazioneEcrParametriCassaEdit;
    },
    setRicercaConfigurazione(
      state: ConfigurazioneSliceState,
      action: PayloadAction<string>
    ) {
      state.ricercaConfigurazione = action.payload;
    },
    resetRicercaConfigurazione(state: ConfigurazioneSliceState) {
      state.ricercaConfigurazione = '';
    },
    setConfigurazioneWeb(
      state: ConfigurazioneSliceState,
      action: PayloadAction<ConfigurazioneWeb_interface>
    ) {
      state.configurazioneWeb = action.payload;
    },
    setOpenConfigurazioneSTS(
      state: ConfigurazioneSliceState,
      action: PayloadAction<boolean>
    ) {
      state.openConfigurazioneSTS = action.payload;
    },

    setMenuConfigOpened(
      state: ConfigurazioneSliceState,
      action: PayloadAction<boolean>
    ) {
      state.menuConfigOpened = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setConfigurazioneEcrEdit,
  setConfigurazioneEcrParametriCassaEdit,
  resetConfigurazioneEcrEdit,
  setConfigurazioneEcrCassaSel,
  setRicercaConfigurazione,
  resetRicercaConfigurazione,
  setConfigurazioneWeb,
  setOpenConfigurazioneSTS,
  setMenuConfigOpened,
} = ConfigurazioneSlice.actions;

export default ConfigurazioneSlice.reducer;
